// extracted by mini-css-extract-plugin
export default {"wrapper":"MarginWrapper_wrapper__9PSqs","marginZero":"MarginWrapper_marginZero__LwOKT"};